import { get } from 'lodash'

const GET_REPORTS = 'dofe-bo/common/GET_REPORTS'
const GET_REPORTS_SUCCESS = 'dofe-bo/common/GET_REPORTS_SUCCESS'
const GET_REPORTS_FAIL = 'dofe-bo/common/GET_REPORTS_FAIL'

const GENERATE_XLS = 'dofe-bo/common/GENERATE_XLS'
const GENERATE_XLS_SUCCESS = 'dofe-bo/common/GENERATE_XLS_SUCCESS'
const GENERATE_XLS_FAIL = 'dofe-bo/common/GENERATE_XLS_FAIL'

const UPDATE_REPORT = 'dofe-bo/common/UPDATE_REPORT'
const UPDATE_REPORT_SUCCESS = 'dofe-bo/common/UPDATE_REPORT_SUCCESS'
const UPDATE_REPORT_FAIL = 'dofe-bo/common/UPDATE_REPORT_FAIL'

const GET_REPORT_CODE = 'dofe-bo/common/GET_REPORT_CODE'
const GET_REPORT_CODE_SUCCESS = 'dofe-bo/common/GET_REPORT_CODE_SUCCESS'
const GET_REPORT_CODE_FAIL = 'dofe-bo/common/GET_REPORT_CODE_FAIL'

const CREATE_AUTH_COD = 'dofe-bo/common/CREATE_AUTH_COD'
const CREATE_AUTH_COD_SUCCESS = 'dofe-bo/common/CREATE_AUTH_COD_SUCCESS'
const CREATE_AUTH_COD_FAIL = 'dofe-bo/common/CREATE_AUTH_COD_FAIL'

const initialState = {
  list: [],
  export: {},
  authCode: null,
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REPORTS:
      return {
        ...state,
        loading: true
      }
    case GET_REPORTS_SUCCESS:
      return {
        ...state,
        list: action.result,
        loading: false,
        loaded: true
      }
    case GET_REPORTS_FAIL:
      return {
        ...state,
        list: [],
        loading: false,
        loaded: false
      }

    case GENERATE_XLS:
      return {
        ...state,
        loading: true
      }
    case GENERATE_XLS_SUCCESS:
      return {
        ...state,
        export: action.result,
        loading: false,
        loaded: true
      }
    case GENERATE_XLS_FAIL:
      return {
        ...state,
        list: [],
        loading: false,
        loaded: false
      }

    case CREATE_AUTH_COD:
      return {
        ...state,
        authCode: null
      }
    case CREATE_AUTH_COD_SUCCESS:
      return {
        ...state,
        authCode: get(action, 'result.code')
      }
    case CREATE_AUTH_COD_FAIL:
      return {
        ...state,
        authCode: null
      }
    case UPDATE_REPORT:
      return {
        ...state,
        authCode: null
      }
    case UPDATE_REPORT_SUCCESS:
      return {
        ...state,
      }
    case UPDATE_REPORT_FAIL:
      return {
        ...state,
        authCode: null
      }
    default:
      return state
  }
}

export function getReports() {
  return {
    types: [GET_REPORTS, GET_REPORTS_SUCCESS, GET_REPORTS_FAIL],
    promise: client => client.get('api/reports')
  }
}

export function generateXlsExport(data) {
  return {
    types: [GENERATE_XLS, GENERATE_XLS_SUCCESS, GENERATE_XLS_FAIL],
    promise: client => client.post('api/exports/xls', { data })
  }
}

export function update(id, data) {
  return {
    types: [UPDATE_REPORT, UPDATE_REPORT_SUCCESS, UPDATE_REPORT_FAIL],
    promise: client => client.post(`apiv2/report/${id}/update`, { data })
  }
}


export function getReportAuthCode(id) {
  return {
    types: [GET_REPORT_CODE, GET_REPORT_CODE_SUCCESS, GET_REPORT_CODE_FAIL],
    promise: client => client.post(`api/reports/${id}/authorization`)
  }
}

export function createAuthCode() {
  return {
    types: [CREATE_AUTH_COD, CREATE_AUTH_COD_SUCCESS, CREATE_AUTH_COD_FAIL],
    promise: client => client.post('api/reports/authorizationCodeCreation')
  }
}
